import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'Components/UI/BehavioralFormElement/Checkbox/BlueCheckbox';
import DateRange from 'Components/UI/BehavioralFormElement/NormalizedInput/DateRange';
import Select from 'Components/UI/BehavioralFormElement/Select';
import Icon from 'Components/UI/Icon';
import paymentMethods from 'Consts/PaymentMethods';
import { noop } from 'Helpers/PropTypes';
import { insertHeader, optionsFromText } from 'Helpers/Select';
import { addSpacesAndCapitalize } from 'Helpers/Formats';
import {
  NOT_INTERESTED,
  CHURNED,
  REMOVED,
  OUT_OF_TARGET,
  UNRESPONSIVE,
} from 'Consts/Status';

import './index.css';
import { ACTIVE, PROSPECT, OTHER } from 'Classes/Household';

class Filters extends Component {
  constructor(props) {
    super(props);
    this.setStatus = this.setStatus.bind(this);
    this.otherFilters = [
      NOT_INTERESTED,
      CHURNED,
      REMOVED,
      OUT_OF_TARGET,
      UNRESPONSIVE,
      OTHER,
    ];
    this.otherFilters = this.otherFilters.map(item => addSpacesAndCapitalize(item));
  }

  setStatus(name, value) {
    const { onFilterChange, status } = this.props;
    const modifiedStatus = [].concat(status);
    if (name === OTHER) {
      this.addOrRemoveOtherFilters(name, value);
      return;
    }
    if (value) {
      modifiedStatus.push(name);
    } else {
      const index = modifiedStatus.indexOf(name);
      if (index > -1) {
        modifiedStatus.splice(index, 1);
      }
    }
    onFilterChange('status', modifiedStatus);
  }

  addOrRemoveOtherFilters(name, value) {
    const { onFilterChange, status } = this.props;
    const modifiedStatus = [].concat(status);
    if (value) {
      this.otherFilters.forEach(f => modifiedStatus.push(f));
    } else {
      this.otherFilters.forEach((f) => {
        const index = modifiedStatus.indexOf(f);
        if (index > -1) {
          modifiedStatus.splice(index, 1);
        }
      });
    }
    onFilterChange('status', modifiedStatus);
  }

  render() {
    const {
      props: {
        isBeta,
        milestoneDate,
        lastMeetingDate,
        onFilterChange,
        paymentMethod,
        signatureDate,
        status,
        escalated,
      },
      setStatus,
    } = this;
    const prospect = status.indexOf(PROSPECT) > -1;
    const active = status.indexOf(ACTIVE) > -1;
    const other = status.indexOf(OTHER) > -1;
    return (
      <div className="Filters">
        <div className="filter-head">
          <Icon icon="filterSliders" />
          Filters
        </div>
        <ul>
          <li>
            <div>Status</div>
            <ul className="status-filter-list">
              <li>
                <Checkbox
                  name="Prospect"
                  checked={prospect}
                  onChange={setStatus}
                />
                <span>Prospect</span>
              </li>
              <li>
                <Checkbox name="Active" checked={active} onChange={setStatus} />
                <span>Active</span>
              </li>
              <li>
                <Checkbox name="Other" checked={other} onChange={setStatus} />
                <span>Other</span>
              </li>
            </ul>
          </li>
          <li>
            <div>Escalated</div>
            <ul className="status-filter-list">
              <li>
                <Checkbox
                  name="escalated"
                  checked={escalated}
                  onChange={onFilterChange}
                />
                <span>Yes</span>
              </li>
              <li>
                <Checkbox
                  name="escalated"
                  checked={!escalated}
                  onChange={name => onFilterChange(name, false)}
                />
                <span>No</span>
              </li>
            </ul>
          </li>
          <li>
            <div>Beta</div>
            <ul className="status-filter-list">
              <li>
                <Checkbox
                  name="isBeta"
                  checked={isBeta}
                  onChange={onFilterChange}
                />
                <span>Yes</span>
              </li>
              <li>
                <Checkbox
                  name="isBeta"
                  checked={!isBeta}
                  onChange={name => onFilterChange(name, false)}
                />
                <span>No</span>
              </li>
            </ul>
          </li>
          <li>
            <div>Next Meeting Date</div>
            <DateRange
              name="milestoneDate"
              onChange={onFilterChange}
              value={milestoneDate}
            />
          </li>
          <li>
            <div>Last Meeting Date</div>
            <DateRange
              name="lastMeetingDate"
              onChange={onFilterChange}
              value={lastMeetingDate}
            />
          </li>
          <li>
            <div>Payment Method</div>
            <Select
              name="paymentMethod"
              onChange={onFilterChange}
              options={insertHeader(
                optionsFromText(paymentMethods),
                'Select Payment Method',
              )}
              value={paymentMethod}
            />
          </li>
          <li>
            <div>Signed PA Date</div>
            <DateRange
              name="signatureDate"
              onChange={onFilterChange}
              value={signatureDate}
            />
          </li>
        </ul>
      </div>
    );
  }
}

Filters.propTypes = {
  isBeta: PropTypes.bool.isRequired,
  milestoneDate: PropTypes.arrayOf(PropTypes.number),
  lastMeetingDate: PropTypes.arrayOf(PropTypes.number),
  onFilterChange: PropTypes.func,
  paymentMethod: PropTypes.string.isRequired,
  signatureDate: PropTypes.arrayOf(PropTypes.number),
  status: PropTypes.arrayOf(PropTypes.string).isRequired,
  escalated: PropTypes.bool.isRequired,
};

Filters.defaultProps = {
  milestoneDate: undefined,
  lastMeetingDate: undefined,
  onFilterChange: noop,
  signatureDate: undefined,
};

export default Filters;
